<template>
    <div class="row mb-3">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <div class="container">
                        <footer class="py-5">
                            <div class="row row-cols-1 row-cols-sm-4">
                                <div class="col">
                                    <h5>Section</h5>
                                    <ul class="nav flex-column">
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Home</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Features</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Pricing</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">FAQs</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">About</a></li>
                                    </ul>
                                </div>

                                <div class="col">
                                    <h5>Section</h5>
                                    <ul class="nav flex-column">
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Home</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Features</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Pricing</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">FAQs</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">About</a></li>
                                    </ul>
                                </div>

                                <div class="col">
                                    <h5>Section</h5>
                                    <ul class="nav flex-column">
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Home</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Features</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">Pricing</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">FAQs</a></li>
                                        <li class="nav-item mb-2"><a href="#" class="nav-link p-0 text-muted">About</a></li>
                                    </ul>
                                </div>

                                <div class="col">
                                    <form>
                                        <h5>Subscribe to our newsletter</h5>
                                        <p>Monthly digest of whats new and exciting from us.</p>
                                        <div class="d-flex w-100 gap-2">
                                            <label for="newsletter1" class="visually-hidden">Email address</label>
                                            <input id="newsletter1" type="text" class="form-control" placeholder="Email address">
                                            <button class="btn btn-primary" type="button">Subscribe</button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div class="row row-cols-1 row-cols-sm-2 mt-4 pt-3 border-1 border-top text-muted small">
                                <div class="col">
                                    <p v-html="G.footerPowered"></p>
                                </div>
                                <div class="col d-flex">
                                    <ul class="list-unstyled d-flex ms-auto">
                                        <li class="ms-3"><a class="" href="#"><i class="fab fa-google"></i></a></li>
                                        <li class="ms-3"><a class="" href="#"><i class="fab fa-youtube"></i></a></li>
                                        <li class="ms-3"><a class="" href="#"><i class="fab fa-twitter"></i></a></li>
                                        <li class="ms-3"><a class="" href="#"><i class="fab fa-instagram"></i></a></li>
                                        <li class="ms-3"><a class="" href="#"><i class="fab fa-facebook-f"></i></a></li>
                                        <li class="ms-3"><a class="" href="#"><i class="fab fa-whatsapp"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </footer>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { G } from '@/_common';

export default {
    name: 'FooTer1',
    setup() {
        return { G };
    },
}
</script>